import { BuilderModel } from "../Models/BuilderModel";

export class LocalButtonStorageService
{
    private static STORAGE_KEY = 'urlo_builder_draft';

    public static Get(): BuilderModel | null
    {
        const stored = localStorage.getItem(LocalButtonStorageService.STORAGE_KEY);

        if (stored)
        {
            return Object.assign(new BuilderModel(), JSON.parse(stored));
        }
        else
        {
            return null;
        }
    }

    public static Set(model: BuilderModel)
    {
        localStorage.setItem(LocalButtonStorageService.STORAGE_KEY, JSON.stringify(model));
    }
}
